module.exports = __webpack_public_path__ + "static/media/upperImage.30887b2b.jpeg";